import {
  Box,
  Flex,
  Image,
  List,
  ListIcon,
  ListItem,
  Text,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { generateMenu, menu2 } from "./sideBarLinks";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import icsanLogo from "../../Assets/Images/ncs-logo.svg";
import { IoLogOut } from "react-icons/io5";
import { removeUser } from "../../redux/slices/authSlice";
import { useNavigate } from "react-router-dom";
import { BiCaretDown, BiCaretUp } from "react-icons/bi";

const Sidebar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedMenu, setSelectedMenu] = useState(null);
  const { pathname } = useLocation();
  const [isCollapsed] = useState(false);
  const [menu, setMenu] = useState("");
  const Permissions = useSelector(
    (state) => state.authPermissions?.Permissions
  );
  const userType = useSelector((state) => state.auth?.user?.userType);

  useEffect(() => {
    if (userType === "Administrative") {
      if (Permissions) {
        if (Array.isArray(Permissions)) {
          const result = generateMenu(Permissions);
          setMenu(result);
        } else if (Permissions) {
          // Convert Permissions into an array
          const result = generateMenu([Permissions]);
          setMenu(result);
        }
      }
    } else if (userType === "Individual"|| userType === "Corporate"  ) {
      setMenu(menu2);
    }
  }, [Permissions, userType]);
  const handleMenuItemClick = (name) => {
    if (selectedMenu === name) {
      setSelectedMenu(null);
    } else {
      setSelectedMenu(name);
    }
  };

  const handleDropdownClick = (name) => {
    if (selectedMenu === name) {
      setSelectedMenu(null);
    } else {
      setSelectedMenu(name);
    }
  };

  const signOut = () => {
    dispatch(removeUser());
    localStorage.removeItem("persist:root");
    navigate("/");
  };

  return (
    <Flex
      as={"nav"}
      pt={5}
      direction="column"
      w={isCollapsed ? "5rem" : "20%"}
      bgColor={"brand.primary"}
      h="100%"
      color={"#ffffff"}
      transition={"all 0.5s ease"}
      position={"fixed"}
      align={"center"}
      left={0}
      top={0}
      bottom={0}
      zIndex={100}
      display={["none", "none", "none", "flex"]}
    >
      <Box h="3rem">
        <Image
          src={icsanLogo}
          onClick={() => navigate(0)}
          cursor={"pointer"}
          alt="NCS Logo"
        />
      </Box>
      <List
        mt={5}
        pt={5}
        pb={10}
        spacing={5}
        alignSelf={"stretch"}
        sx={{
          "& svg": {
            width: "1.5rem",
            height: "1.5rem",
            "& + span": {
              display: isCollapsed ? "none" : "inline",
            },
          },
          overflowY: "scroll",
          "&::-webkit-scrollbar": {
            width: "0px",
          },
          scrollbarWidth: "none",
        }}
      >
        {menu &&
          menu?.map((section) => (
            <React.Fragment key={section?.heading}>
              <Text
                px={5}
                fontWeight={"400"}
                fontSize={"12px"}
                color="rgba(30, 30, 30, 0.5)"
              >
                {section?.heading}
              </Text>
              {section?.items?.map(({ name, link, icon, submenu }, index) => {
                return !submenu ? (
                  <ListItem
                    key={index}
                    as={NavLink}
                    to={link}
                    py={3}
                    display={"flex"}
                    justify={"center"}
                    position="relative"
                    onClick={() => handleMenuItemClick(name)}
                  >
                    {({ isActive }) => (
                      <Flex
                        alignItems={"center"}
                        // color={selectedMenu === name ? "#D11A2A" : null}
                        color={pathname.includes(link) ? "black" : "#fff"}
                        // bgColor={pathname.includes(link) ? "#ffffff3a" : null}
                        minW={"80%"}
                        // mx="auto"
                        gap={3}
                        px={5}
                      >
                        <Box
                          position={"absolute"}
                          left={0}
                          width={"full"}
                          height={"full"}
                          zIndex={-1}
                          // bg={isActive && ""}
                        />
                        <ListIcon
                          // flexShrink={0}
                          // flexGrow={0}
                          // flexBasis={"3.5rem"}
                          as={icon}
                          m={0}
                          opacity={isCollapsed && !isActive && 0.5}
                        />
                        <Box as={"span"} flexGrow={1}>
                          {name}
                        </Box>
                      </Flex>
                    )}
                  </ListItem>
                ) : (
                  <React.Fragment>
                    <ListItem
                      key={index}
                      cursor={"pointer"}
                      py={3}
                      display={"flex"}
                      position="relative"
                      onClick={() => handleDropdownClick(name)}
                      mt={[1, 2, 5]}
                    >
                      <Box w="full">
                        <Flex alignItems={"center"} minW={"80%"} gap={3} px={5}>
                          {pathname.includes("userManagement") ||
                          pathname.includes("FeeManagement") ||
                          pathname.includes("Approval") ||
                          pathname.includes("Report") ||
                          pathname.includes("DepartmentManagement") ||
                          pathname.includes("ExamSetup") ? (
                            <Box
                              position={"absolute"}
                              left={0}
                              width={"full"}
                              height={"full"}
                              zIndex={1}
                            />
                          ) : null}
                          <ListIcon
                            zIndex={2}
                            flexShrink={0}
                            flexGrow={0}
                            as={icon}
                            m={0}
                            color={selectedMenu === name ? "black" : null}
                            // color={pathname.includes(link) ? "#D11A2A" : "rgba(30, 30, 30, 0.5)"}
                          />
                          <Text
                            maxW={[null, null, null, "80px", "150px"]}
                            zIndex={2}
                            as={"span"}
                            flexGrow={1}
                            color={selectedMenu === name ? "black" : null}
                          >
                            {name}
                          </Text>
                          {selectedMenu === name ? (
                            <BiCaretUp
                              style={{ marginLeft: "auto", zIndex: 1 }}
                              color={selectedMenu === name ? "black" : null}
                            />
                          ) : (
                            <BiCaretDown
                              style={{ marginLeft: "auto", zIndex: 1 }}
                            />
                          )}
                        </Flex>
                      </Box>
                    </ListItem>
                    {selectedMenu === name ? (
                      <Flex direction={"column"}>
                        {submenu.map(({ name, link }) => {
                          return (
                            <Box
                              pl={9}
                              as={NavLink}
                              to={link}
                              py={2}
                              color={
                                pathname.includes(link) ? "black" : "#fffff6f"
                              }
                            >
                              {({ isActive }) => (
                                <Flex h="full">
                                  {isActive && (
                                    <Box
                                      position={"absolute"}
                                      left={0}
                                      width={"full"}
                                      height={6}
                                      zIndex={1}
                                    />
                                  )}
                                  {name}
                                </Flex>
                              )}
                            </Box>
                          );
                        })}
                      </Flex>
                    ) : null}
                  </React.Fragment>
                );
              })}
            </React.Fragment>
          ))}
        <Flex px={5} gap={5} cursor={"pointer"} onClick={signOut}>
          <IoLogOut style={{ height: "30px", width: "30px" }} />
          <Text fontWeight={"500"}>Logout</Text>
        </Flex>
      </List>
    </Flex>
  );
};

export default Sidebar;
